import { z } from 'zod';

export const DeliveryZoneSchema = z.object({
  id: z.string(),
  name: z.string(),
  region: z.string(),
  country: z.string(),
  type: z.enum(['port', 'airport', 'distribution_center', 'city']),
  address: z.string().optional(),
  coordinates: z.object({
    lat: z.number(),
    lng: z.number(),
  }).optional(),
  isActive: z.boolean(),
  deliveryDays: z.array(z.enum(['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'])),
  leadTimeDays: z.number(),
  minimumOrderValue: z.number().optional(),
  deliveryFee: z.number().optional(),
  notes: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type DeliveryZone = z.infer<typeof DeliveryZoneSchema>;

export const ZoneTypeLabels: Record<DeliveryZone['type'], string> = {
  port: 'Port',
  airport: 'Airport',
  distribution_center: 'Distribution Center',
  city: 'City',
};
